import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { XIcon } from 'lucide-react';
export function ProblemSection() {
  const painPoints = ['Te preguntan por qué un ejercicio y dudás antes de responder', 'Sabés cómo se hace pero no podés justificarlo técnicamente', 'Improvisás frente a tus alumnos sin fundamento claro', 'Buscás información suelta que nunca está organizada', 'Tus alumnos lo notan — y eso frena tu autoridad profesional'];
  return <section className="py-12 bg-background-dark border-y border-card-border-dark" data-id="element-252">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-253">
        <FadeIn className="text-center mb-8" data-id="element-254">
          <h2 className="text-3xl md:text-5xl font-black text-white font-heading mb-2" data-id="element-255">
            Si sos profe de educación física o entrenador,
          </h2>
          <h3 className="text-3xl md:text-5xl font-black text-primary font-heading" data-id="element-256">
            esto pasa en tu próxima clase si no lo resolvés:
          </h3>
        </FadeIn>

        <div className="space-y-3 mb-10" data-id="element-257">
          {painPoints.map((point, index) => <FadeIn key={index} delay={0.1 * index} direction="up" data-id="element-258">
              <div className="bg-card-dark border-l-4 border-l-urgency rounded-r-xl rounded-l-sm p-5 md:p-6 flex items-start gap-4 shadow-lg" data-id="element-259">
                <div className="w-6 h-6 rounded-full bg-urgency/20 flex items-center justify-center shrink-0 mt-0.5" data-id="element-260">
                  <XIcon className="w-4 h-4 text-urgency" data-id="element-261" />
                </div>
                <p className="text-lg md:text-xl text-gray-300 font-medium leading-relaxed" data-id="element-262">
                  {point}
                </p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.6} className="text-center" data-id="element-263">
          <h3 className="text-2xl md:text-4xl font-black text-white font-heading mb-2" data-id="element-264">
            ¿Cuántas clases más vas a dar
          </h3>
          <h4 className="text-2xl md:text-4xl font-black text-primary font-heading mb-2" data-id="element-265">
            sin el respaldo técnico que necesitás?
          </h4>
        </FadeIn>
      </div>
    </section>;
}